<style lang="less" scoped>
.detail-from-input {
  width: 450px;
  margin: 10px 30px;
}

.detail-form-logo {
  margin: 16px 20px;
}

.margin-bt-10 {
  margin-bottom: 40px;
}

.detail-body-title {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
}

.upload-logo {
  width: 30%;
}

.app-card-style img {
  width: 350px;
  height: 160px;
  border-radius: 5px;
  cursor: pointer;
}

.app-card-style {
  display: flex;
  flex-direction: column;
}

.box {
  position: relative;
  width: 348px;
  height: 160px;
  overflow: hidden;
  border: 3px solid #4390df;
  border-radius: 6px;

}

.box:before {
  position: absolute;
  display: block;
  border-top: 20px solid #4390df;
  border-left: 20px solid transparent;
  right: 0;
  top: 0;
  content: "";
  z-index: 101;
}

.box:after {
  position: absolute;
  display: block;
  content: "\2714";
  top: -3px;
  right: 0;
  font-family: Glyphicons Halflings;
  font-size: 3pt;
  font-weight: normal;
  z-index: 102;
  color: #fff;
}

.img-div {
  margin: 10px 45px;
}

.detail-table {
  margin-top: 20px;
}
.dad{
  position: relative;
  .sid{
    position: absolute;
    top: 20%;
    right: 20%;
  }
}
</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{pageTitle}} {{ detailForm.adNo }}</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm" class="detail-form">
          <div class="detail-form-parent-div">
            <div class="margin-bt-10">
              <div class="flex">
                <el-form-item class="detail-from-input" label="广告位置名称" prop="adName">
                  <el-input :disabled="searchFlag"  v-model="detailForm.adName" clearable size="small" placeholder="广告位置名称" maxlength="25"></el-input>
                </el-form-item>
                <el-form-item class="detail-from-input" label="广告轮播时间(S)" prop="picSize">
                  <el-select :disabled="searchFlag" class="full-width" v-model="detailForm.adTime" placeholder="请选择" size="small" clearable>
                    <el-option label="3" value="3"></el-option>
                    <el-option label="5" value="5"></el-option>
                    <el-option label="10" value="10"></el-option>
                  </el-select>
                </el-form-item>
              </div>



              <el-divider ></el-divider>

            </div>
            <div class="margin-bt-10">
              <div class="detail-body-title">图片编辑</div>
              <el-table
                :data="tableData"
                border
                style="width: 100%"

              >
                <el-table-column label="图片顺序" type="index" width="55"> </el-table-column>
                <el-table-column
                  prop="pictureId"
                  label="图片ID"
                  width="180"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="pictureName"
                  label="活动名称"
                  width="180"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="statusName" label="图片状态" align="center">
                </el-table-column>
                <el-table-column prop="startTime" label="启用时间" align="center">
                </el-table-column>
                <el-table-column prop="endTime" label="结束时间" align="center">
                </el-table-column>
                <el-table-column prop="pictureUrl" label="图片跳转链接" align="center">
                </el-table-column>
                <el-table-column prop="remark" label="备注" align="center">
                </el-table-column>
                <el-table-column prop="lastModifiedByName" label="操作人" align="center">
                </el-table-column>
                <el-table-column prop="lastModifiedWhen" label="操作时间" align="center">
                </el-table-column>
                <el-table-column prop="address" label="操作" align="center" width="210">
                  <template slot-scope="scope">
                    <el-button v-if="!scope.row.startTime" :disabled="searchFlag" @click="handleClick('添加',scope.$index)" size="small"
                    >添加</el-button
                    >
                    <el-button v-if="scope.row.startTime" :disabled="searchFlag" @click="handleClick('编辑',scope.row)" size="small"
                    >编辑</el-button
                    >
                    <el-button v-if="scope.row.startTime" :disabled="searchFlag" @click="handleClick('替换')" size="small"
                    >替换</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="margin-bt-10">
              <div class="detail-body-title">替换列表</div>
              <el-table
                :data="tableData1"
                border
                style="width: 100%"

              >
                <el-table-column label="图片顺序" type="index" width="55"> </el-table-column>
                <el-table-column
                  prop="pictureId"
                  label="图片ID"
                  width="180"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="pictureName"
                  label="活动名称"
                  width="180"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="statusName" label="图片状态" align="center">
                </el-table-column>
                <el-table-column prop="startTime" label="启用时间" align="center">
                </el-table-column>
                <el-table-column prop="endTime" label="结束时间" align="center">
                </el-table-column>
                <el-table-column prop="pictureUrl" label="图片跳转链接" align="center">
                </el-table-column>
                <el-table-column prop="remark" label="备注" align="center">
                </el-table-column>
                <el-table-column prop="lastModifiedByName" label="操作人" align="center">
                </el-table-column>
                <el-table-column prop="lastModifiedWhen" label="操作时间" align="center">
                </el-table-column>
                <el-table-column prop="address" label="操作" align="center" width="170">
                  <template slot-scope="scope">
                    <el-button v-if="scope.row.startTime" :disabled="searchFlag" @click="handleClick('替换编辑',scope.row)" size="small"
                    >编辑</el-button
                    >
                    <el-button v-if="scope.row.startTime" :disabled="searchFlag" @click="handleClick('替换停用')" size="small"
                    >停用</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <el-dialog
              :title="title"
              :visible.sync="centerDialogVisible"
              width="50%"
            >
              <el-form :model="listForm" :rules="listFormRules" ref="listForm" class="detail-form">
                <div class="detail-form-parent-div">
                  <div class="margin-bt-10">
                    <div class="flex">
                      <el-form-item class="detail-from-input" label="活动名称" prop="pictureName">
                        <el-input v-model="listForm.pictureName" :disabled="editFlag" clearable size="small" placeholder="请输入优惠券名称（20字以内）" maxlength="20"></el-input>
                      </el-form-item>
                      <el-form-item class="detail-form-logo detail-body-title"  label="图片上传" prop="imgUrl">
                        <el-upload class="upload-demo upload-logo"
                                   action=""
                                   :http-request="toUploadImg"
                                   :on-exceed="handleExceed"
                                   :on-preview="handleLogoPreview"
                                   :on-remove="handleLogoRemove"
                                   :file-list="logoFileList"
                                   :limit="1"
                                   :before-upload="beforeAvatarUpload"
                                   list-type="picture"
                        >
                          <img :src="detailForm.imgUrl" alt="">
                          <el-button size="small" :disabled="editFlag" type="primary">点击上传</el-button>
                          <div slot="tip" class="el-upload__tip">只能上传 jpg / jpeg / bmp / gif / png 文件(仅1张)，且不超过1M</div>
                        </el-upload>
                      </el-form-item>
                    </div>
                  </div>

                  <div class="margin-bt-10">
                    <div class="flex">
                      <div>
                        <el-form-item class="detail-from-input" label="启用时间" prop="startTime">
                          <el-date-picker
                            v-model="listForm.startTime"
                            style="width: 320px"
                            type="date"
                            size="small"
                            value-format="yyyy-MM-dd 00:00:00"
                            range-separator="-"
                            :disabled="editFlag"

                          ></el-date-picker>
                        </el-form-item>
                      </div>

                      <div>
                        <el-form-item class="detail-from-input" label="结束时间" prop="filterType">
                          <el-radio-group v-model="listForm.filterType" :disabled="editFlag" @change="filterTypeChange">
                            <el-radio label="01">具体时间</el-radio>
                            <el-radio label="02">永久</el-radio>
                          </el-radio-group> <br>
                          <el-date-picker
                            v-model="listForm.endTime"
                            style="width: 320px"
                            type="date"
                            size="small"
                            value-format="yyyy-MM-dd 00:00:00"
                            range-separator="-"
                            :disabled="  editFlag|| endTimeFlag"

                          ></el-date-picker>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                  <div class="margin-bt-10">
                    <div class="flex">
                      <el-form-item class="detail-from-input" label="跳转地址" prop="pictureUrl">
                        <el-input :disabled="editFlag" v-model="listForm.pictureUrl" clearable placeholder="请输入50字以内跳转地址" size="small" maxlength="25"></el-input>
                        若无跳转,则填入"/"
                      </el-form-item>
                    </div>
                    <el-form-item class="detail-from-input" label="备注">
                      <el-input  maxlength="50"  v-model="listForm.remark" clearable placeholder="50字以内备注"></el-input>
                    </el-form-item>
                  </div>
                  <div  class="margin-bt-10">
                    <div class="flex">
                      <div v-if="editFlag">
                        <el-form-item class="detail-form-logo detail-body-title"  label="停用编辑">
                          <el-radio-group v-model="listForm.status" @click.native="statusChange($event)">
                            <el-radio label="03">停用</el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </div>
                    </div>
                  </div>

                </div>
              </el-form>
              <span slot="footer" class="dialog-footer">
                                <el-button @click="centerDialogVisible = false">取 消</el-button>
                                <el-button type="primary" @click="submitForm('listForm')">确 定</el-button>
                            </span>
            </el-dialog>

          </div>
        </el-form>

      </div>
      <div class="detail-content-footer-div">
        <button class="common-bg-button" v-if="!searchFlag" @click="submit('detailForm')">提 交</button>
        <button class="common-empty-button" @click="resetForm">取 消</button>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config';
export default {

  data() {
    let validateFileUrl = (rule, value, callback) => {
      if (this.logoFileList.length < 1) {//我控制了FileList 长度代表文件个数
        callback(new Error("请上传文件"))
      } else {
        callback()
      }
    }
    return {
      listFormRules : {
        pictureName: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
        startTime: [{ required: true, message: '请选择启用时间', trigger: 'change' }],
        // endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        filterType: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        pictureUrl: [{ required: true, message: '请输入跳转地址', trigger: 'blur' }],
        imgUrl: [
          {  required: true, message: '请上传图片',trigger: 'change'}
        ],
      },
      couponStatusName:'',
      title:'添加',
      pageConfig,
      filterType:'',
      tableData:[
        {
          adNo:'',
          adName:'',
          startTime:'',
          endTime:'',
          pictureUrl:'',
          remark:''
        },
        {
          adNo:'',
          adName:'',
          startTime:'',
          endTime:'',
          pictureUrl:'',
          remark:''
        },
        {
          adNo:'',
          adName:'',
          startTime:'',
          endTime:'',
          pictureUrl:'',
          remark:''
        },
        {
          adNo:'',
          adName:'',
          startTime:'',
          endTime:'',
          pictureUrl:'',
          remark:''
        },
        {
          adNo:'',
          adName:'',
          startTime:'',
          endTime:'',
          pictureUrl:'',
          remark:''
        },
        {
          adNo:'',
          adName:'',
          startTime:'',
          endTime:'',
          pictureUrl:'',
          remark:''
        },

      ],
      tableData1:[
        {
          adNo:'',
          adName:'',
          startTime:'',
          endTime:'',
          pictureUrl:'',
          remark:''
        },
      ],
      logoFileList:[],
      centerDialogVisible:false,
      editFlag: false, //表单是否编辑状态
      disabledVersion:true,
      pageTitle: '广告位ID',
      pileVersionNo:'1',
      // 默认值设置
      detailForm: {

      },
      listForm:{
        imgBs:''
      },
      searchFlag:false,
      endTimeFlag:false,
      endRule:'',
      index :'',

    }
  },
  methods: {
    filterTypeChange(val){
      if(val == '02'){
        this.endTimeFlag = true
        this.endRule = ''
      }else{
        this.endTimeFlag = false
        this.endRule = 'endTime'
      }
    },
    handleClick(val1,val2){
      console.log(val2);
      if(val1 == '添加'){
        this.listForm ={
          pictureName:'',
          startTime:'',
          endTime:'',
          pictureUrl:'',
          remark:''
        }
        this.filterType = ''
        this.logoFileList = []
        this.editFlag = false
        this.centerDialogVisible = true
        this.title = '图片添加'
        this.index = val2
      }
      if(val1 == '编辑'){
        console.log(1);
        this.centerDialogVisible = true
        this.title = '图片编辑'
        console.log(val2);
        this.listForm = val2
        this.listForm.imgUrl = this.listForm.pictureUrl
        if(this.listForm.endTime){
          this.listForm.filterType = '01'
        }else{
          this.listForm.filterType = '02'
        }
        if (this.listForm.pictureUrl) {
          let imgObj = {}
          imgObj.name = 'pileImg';
          imgObj.url = this.listForm.pictureUrl;
          this.logoFileList[0] = imgObj;
        }
        this.editFlag = true
      }
      if(val1 == '替换'){
        this.listForm ={
          pictureName:'',
          startTime:'',
          endTime:'',
          pictureUrl:'',
          remark:''
        }
        this.logoFileList = []
        this.editFlag = false
        this.centerDialogVisible = true
        this.title = '图片替换'

      }
      if(val1 == '替换编辑'){
        this.centerDialogVisible = true
        this.title = '替换编辑'
        this.listForm = val2
      }
      if(val1 == '替换停用'){
        this.listForm ={
          pictureName:'',
          startTime:'',
          endTime:'',
          pictureUrl:'',
          remark:''
        }
        this.logoFileList = []
        this.editFlag = false
        this.centerDialogVisible = true
        this.title = '替换停用'
      }

    },
    statusChange(e){
      console.log(e.target.tagName);
      if (e.target.tagName === "INPUT") {
        if (this.listForm.status === "") {

          this.listForm.status = '03'
          this.listForm.statusName = '停用'
        } else {

          this.listForm.status = ''
          this.listForm.statusName = ''
        }
      }

    },
    changeVersionNo(val){
      this.detailForm.pileVersionNo = val
    },
    //是否为编辑模式
    init() {

      if (localStorage.getItem('advDetail')) {
        this.editFlag = true;
        this.detailForm = JSON.parse(localStorage.getItem('advDetail'))
        pageConfig.detailBreadCrumb[3].name = "编辑";
        console.log(this.detailForm);
        this.getListData()
        this.url = this.$A.digitization.pileFunctionEdit;
      }
      if(this.$route.params.search){
        this.searchFlag = true
        pageConfig.detailBreadCrumb[3].name = "查看";
      }
    },
    // 获取表格数据
    getListData() {
      let _ = this;
      _.$U.showLoading(_);
      let obj = {
        advertId:_.detailForm.id,
        isDel:'N'
      }
      _.$H
        .post(_, _.$A.coupon.advertPictureList, obj)
        .then((res) => {
          res.data.data.forEach(item=>{
            if(item.isMaster == 'Y'){
              _.tableData.push(item);
            }else{
              _.tableData1.push(item);
            }
          })
          // _.pagination.total = res.data.data.totalElements || 0;
          _.$U.hideLoading(_);
        });
    },
    // 获取表单信息
    getFormInfo() {
      let _ = this;
      _.$H.post(_, _.$A.digitization.findPileFunctionByNo,{ pileTypeNo: _.detailForm.pileTypeNo}).then((res)=> {
        _.detailForm = res.data.data;
        if(!_.detailForm.pileVersionNo){
          _.detailForm.pileVersionNo = '1'

        }

        _.logoFileList = [];
        if (_.detailForm.pileImgUrl) {
          let imgObj = {}
          imgObj.name = 'pileImg';
          imgObj.url = _.detailForm.pileImgUrl;
          _.logoFileList.push(imgObj);
        }
        return
      });
    },
    // 表单提交
    submitForm(formName) {
      let _ = this;

      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(2);
          if(_.title == '图片添加'){
            if(_.listForm.filterType == '01'&&!_.listForm.endTime){
              return _.$message.error('请选择具体结束时间')
            }

            _.listForm.isMaster = 'Y'
            _.listForm.advertId = _.detailForm.id

            if(_.filterType == '02'){
              delete _.listForm.endTime
            }
            if(_.listForm.endTime&&new Date(_.listForm.startTime)>new Date(_.listForm.endTime)){
              return _.$message.error('启用时间要小于结束时间')
            }
            _.$H.post(_, _.$A.coupon.advertPictureAdd, _.listForm).then(res => {
              // _.tableData[_.index] = res.data.data
              _.tableData.splice(_.index,1,res.data.data)
              _.centerDialogVisible = false
            })
          }
          if(_.title == '图片编辑') {
            _.listForm.isMaster = 'Y'
            _.listForm.advertId = _.detailForm.id
            if(_.filterType == '02'){
              delete _.listForm.endTime
            }
            if(_.listForm.status == '03'){
              _.listForm.statusName = '停用'
            }
            _.$H.post(_, _.$A.coupon.advertPictureEdit, _.listForm).then(res => {
              _.tableData.forEach((item,index)=>{
                if(item.pictureId == _.listForm.pictureId){
                  _.tableData.splice(index,1,res.data.data)
                }
              })
              // _.getListData()
              _.centerDialogVisible = false
            })
          }
          if(_.title == '图片替换') {
            _.listForm.isMaster = 'Y'
            _.listForm.advertId = _.detailForm.id
            delete _.detailForm.id
            if(_.filterType == '02'){
              delete _.listForm.endTime
            }
            _.$H.post(_, _.$A.coupon.advertPictureReplace, _.listForm).then(res => {
              _.tableData.forEach((item,index)=>{
                if(item.pictureId == _.listForm.pictureId){
                  _.tableData.splice(index,1,res.data.data)
                }
              })
              // _.getListData()
              _.centerDialogVisible = false
            })
          }
          if(_.title == '替换停用') {
            _.listForm.isMaster = 'N'
            _.listForm.advertId = _.detailForm.id
            // delete _.detailForm.id
            if(_.filterType == '02'){
              delete _.listForm.endTime
            }
            _.$H.post(_, _.$A.coupon.advertPictureEditStatus, _.listForm).then(res => {
              _.getListData()
              _.centerDialogVisible = false
            })
          }
          if(_.title == '替换编辑') {
            _.listForm.isMaster = 'N'
            _.listForm.advertId = _.detailForm.id
            delete _.detailForm.id
            if(_.filterType == '02'){
              delete _.listForm.endTime
            }
            _.$H.post(_, _.$A.coupon.advertPictureEdit, _.listForm).then(res => {
              _.getListData()
              _.centerDialogVisible = false
            })
          }
          // _.$S.submitForm(_, _.url, true, formData, pageConfig.listRouter);
        }
      })

    },
    // 表单提交
    submit(formName) {
      let _ = this;
      console.log(1);
      this.$refs[formName].validate((valid) => {
        if (valid) {

          _.$H.put(_, _.$A.coupon.advertisement, _.detailForm).then(res => {
            this.$router.push({
              name: pageConfig.listRouter
            })
          })

        }
      })
      // this.$refs[formName].validateField(_.ruleArr, valid => {
      //     if (valid) {
      //         suc = false;
      //     }
      //     // num++;
      //     if (suc) {
      //         _.$S.submitForm(_, _.url, true, formData, pageConfig.listRouter);
      //     }
      // });
    },
    changeSelect (val) {
      this.$nextTick(() => {
        console.log(this.$refs[val]);
        this.detailForm[val] = this.$refs[val].selected.value
        this.detailForm[`${val}Name`] = this.$refs[val].selected.label
        console.log(this.detailForm);
        // for (let i = 0; i < arr.length; i++) {
        //     console.log(arr[i].label, i)
        // console.log(arr[i].currentValue, i)
        //     console.log(arr[i].currentLabel, i)
        // }
      })
    },
    //上传logo图片
    toUploadLogoImg(param) {
      this.logoFile = param.file;
    },
    handleExceed(files, fileList){
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      // console.log(fileList);
    },
    //清楚logo图片
    handleLogoRemove(file, fileList) {
      this.detailForm.pileImgUrl = '';
      this.logoFileList = []
      this.logoFile = null;
    },
    //预览logo
    handleLogoPreview(file,fileList) {

      this.logoFileList = fileList
    },
    //上传logo图片限制
    beforeAvatarUpload(file) {
      let logoType = false;
      if (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/bmp' || file.type === 'image/gif' || file.type === 'image/png') {
        logoType = true;
      }
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (!logoType) {
        this.$message.error('上传logo图片只能是 jpg / jpeg / bmp / gif / png 格式!');
      }
      if (!isLt1M) {
        this.$message.error('上传logo图片大小不能超过 1MB!');
      }
      return logoType && isLt1M;
    },
    //上传图片
    toUploadImg(item) {
      let _ = this;
      let fd = new FormData();
      fd.append('file', item.file)
      _.$H.postFormData(_, _.$A.coupon.upload, fd).then(res => {
        if(res.data.status === 200){
          _.listForm.pictureUrl = res.data.data.viewPath || '';
          _.listForm.imgUrl = res.data.data.viewPath || '';
          _.$U.success("图片上传成功！")
          _.$nextTick(() => {_.$refs['listForm'].clearValidate('imgUrl')})
        }
      })
    },
    //删除上传图片
    handleRemove(file, fileList) {
      this.contractFile = null;

    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    //删除附件前提示
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    // 取消
    resetForm() {
      this.$router.push({
        name: pageConfig.listRouter
      })
    },

  },

  mounted() {
    this.init();
  }
}
</script>
